import { WpActivity } from './wp-activity.model';

export class ParticipationHrs  {
    constructor(
        public id?: number,
        public completedHrs?: number,
        public excusedHrs?: number,
        public fedHolidayHrs?: number,
        public monthOrYearReviewSw?: string,
        public participationStatusCd?: string,
        public performanceReviewSw?: string,
        public reportedActCompCd?: string,
        public reportedActCompTypeCd?: string,
        public reportedActivityBeginDt?: any,
        public reportedActivityChangeRequestSw?: string,
        public reportedActivityEndDt?: any,
        public reportedActivityVerificationCd?: string,
        public totalHrs?: any,
        public weekFiveHrs?: any,
        public weekFourHrs?: any,
        public weekThreeHrs?: any,
        public weekTwoHrs?: any,
        public weekOneHrs?: any,
        public acceptSupervisionCd?: string,
        public attitudeCd?: string,
        public cooperationCd?: string,
        public courtesyCd?: string,
        public goodCauseDescription?: string,
        public activityGoodCauseComments?: string,
        public goodCauseReasonCd?: string,
        public goodCauseRequest?: any,
        public goodCauseSw?: string,
        public goodCauseVerificationCd?: string,
        public judgementCd?: string,
        public overallPerfCd?: string,
        public perfDutiesCd?: string,
        public perfReviewedDate?: any,
        public perfexcusedHrs?: number,
        public performanceComments?: string,
        public punctualityCd?: string,
        public supervisorEmailId?: string,
        public supervisorName?: string,
        public supervisorPhone?: string,
        public willingToWorkCd?: string,
        public worksWellWithOthersCd?: string,
        public wpActivity?: WpActivity,
        public disable?: boolean,
        public participationMonth?: number
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-participation-hrs.model.ts